import { render, staticRenderFns } from "./MissingMandatoryStep.vue?vue&type=template&id=2c8e4aea&scoped=true&"
import script from "./MissingMandatoryStep.vue?vue&type=script&lang=ts&"
export * from "./MissingMandatoryStep.vue?vue&type=script&lang=ts&"
import style0 from "./MissingMandatoryStep.vue?vue&type=style&index=0&id=2c8e4aea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8e4aea",
  null
  
)

export default component.exports